import React, { useEffect } from 'react';
import { compose, withState } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, Checkbox, Link } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

const styles = {
  dialogContent: {
    fontWeight: 400,
    fontSize: '16px',
    color: '#000000',
    lineHeight: '32px'
  },
  checkBox: {
    padding: '0 8px 0 0'
  },
  checkLine: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 24,
    justifyContent: 'center'
  },
  header: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: '140%',
    textAlign: 'center'
  },
  body: {
    fontSize: 16,
    fontWeight: 400,
    marginTop: 16,
    lineHeight: '160%'
  },
  supportLink: {
    display: 'flex',
    alignItems: 'center',
    textDecorationLine: 'underline'
  },
  supportIcon: {
    marginLeft: '8px'
  },
  contentContainer: {
    padding: '48px 16px 12px !important'
  },
  buttonContainer: {
    padding: '0 16px 48px'
  }
};

const enhance = compose(withState('policy1', 'setPolicy1', false));
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 359
  }
});

const Main = enhance(
  ({ classes, show, okAction, isSmall, policy1, setPolicy1 }) => {
    useEffect(() => {
      setPolicy1(false);
    }, [show]);

    const classesD = useStyles();

    return (
      <Dialog
        open={show}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classesD.paperWidthSm
        }}
      >
        <DialogContent className={classes.contentContainer}>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.dialogContent}
          >
            <div className={classes.header}>
              インボイス制度開始に伴う
              <br />
              加盟店規約更新のお知らせ
            </div>
            <div className={classes.body}>
              <div>
                この度、2023年10月1日よりインボイス制度が開始された事を受け、GOCHIプラットフォーム加盟店規約を更新いたしました。
              </div>
              <div style={{ marginBottom: 8 }}>
                <Link
                  href="https://gochimeshi.com/policy/owner-terms/"
                  target="_blank"
                  className={classes.supportLink}
                >
                  加盟店規約
                  <OpenInNew color="primary" className={classes.supportIcon} />
                </Link>
              </div>
              <div>
                続けて当サービスをご利用いただくには、新しい加盟店規約に同意頂き、下記の「加盟店規約に同意する」にチェックを入れ、「規約に同意して利用する」ボタンを押してください。
              </div>
              <div className={classes.checkLine}>
                <Checkbox
                  color="primary"
                  className={classes.checkBox}
                  checked={policy1}
                  onChange={event => {
                    setPolicy1(event.target.checked);
                  }}
                />
                加盟店規約に同意する
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonContainer}>
          <Button
            color="primary"
            fullWidth
            variant="contained"
            onClick={okAction}
            disabled={!policy1}
          >
            規約に同意して利用する
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
